export class CancellationToken {
  cancelled: boolean = false

  cancel() {
    this.cancelled = true
  }
}

export class CancelError extends Error {
  constructor() {
    super()
    this.name = 'CancelError'
    this.message = 'Operation cancelled'
  }
}
